import { render, staticRenderFns } from "./FaceBook.vue?vue&type=template&id=51097ec3"
import script from "./FaceBook.vue?vue&type=script&lang=js"
export * from "./FaceBook.vue?vue&type=script&lang=js"
import style0 from "./FaceBook.vue?vue&type=style&index=0&id=51097ec3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports